import { Controller } from '@hotwired/stimulus';
import bookBoardUsersOutletController from 'controllers/book_board_users_controller';

export default class extends Controller {
  static outlets = ['book-board-users'];
  static targets = [
    'allAttendButton',
    'singleAttendButton',
    'singleRandomAttendButton',
    'attendMethodSection',
    'AttendField',
  ];
  declare bookBoardUsersOutlet: bookBoardUsersOutletController;
  declare readonly hasBookBoardUsersOutlet: boolean;
  declare hasAllAttendButtonTarget: boolean;
  declare hasSingleAttendButtonTarget: boolean;
  declare hasAttendMethodSectionTarget: boolean;
  declare allAttendButtonTarget: HTMLInputElement;
  declare singleAttendButtonTarget: HTMLInputElement;
  declare singleRandomAttendButtonTarget: HTMLInputElement;
  declare attendMethodSectionTarget: HTMLElement;
  declare AttendFieldTarget: HTMLElement;

  connect(): void {
    this.changeShowPrioritySection();

    // 「全員が参加」が選択されている場合、担当者の割当方式を非表示にする
    if (
      this.hasAllAttendButtonTarget &&
      this.hasSingleAttendButtonTarget &&
      this.hasAttendMethodSectionTarget &&
      this.allAttendButtonTarget.checked
    ) {
      this.hideAttendMethodSection();
    }
  }

  /**
   * 担当者の割り当て方法を変更したら、ユーザリストの data attr を更新する
   *
   * @param event
   */
  changeStyle(event: MouseEvent): void {
    const target = event.currentTarget as HTMLInputElement;
    if (!target.checked) {
      return;
    }

    if (this.hasBookBoardUsersOutlet) {
      // outlet では直接プロパティを変更できないので引数で渡す
      this.bookBoardUsersOutlet.resetUserAttendStyleValue(target.value);
    }
  }

  /**
   * 誰か一名が参加に切り替えたときのUI更新
   */
  updateUIToSingleAttend(): void {
    this.singleRandomAttendButtonTarget.checked = true; // 「ランダム」が選択された状態にする
    this.showAttendMethodSection();
  }

  /**
   * 全員が参加を選択したときのUI更新
   */
  updateUIToAllAttend(): void {
    this.singleAttendButtonTarget.checked = false; // 「誰か一名が参加」の選択を解除
    this.hideAttendMethodSection();
  }

  changeShowPrioritySection(): void {
    const input = document.querySelector('input[value="ordered_single_attend"]') as HTMLInputElement;
    const action = input.checked ? 'add' : 'remove';
    this.AttendFieldTarget.classList[action]('show-priority');
  }

  /**
   * 担当者の割当方式を非表示にする
   */
  hideAttendMethodSection(): void {
    this.attendMethodSectionTarget.style.display = 'none';
  }

  /**
   * 担当者の割当方式を表示する
   */
  showAttendMethodSection(): void {
    this.attendMethodSectionTarget.style.display = 'block';
  }
}
